import { useContext, useEffect } from "react";
import { useNavigate } from "react-router";

import LeadCustomFieldsContainer from "../components/lead-custom-fields";
import { AuthContext } from "../context/AuthContext";
import { userRoles } from "../config";

const LeadCustomFields = () => {
  const navigate = useNavigate();
  const {
    isAuthenticated,
    isLeadCustomFieldView,
    isLeadCustomFieldCreate,
    isLeadCustomFieldEdit,
    isLeadCustomFieldDelete,
    user,
  } = useContext(AuthContext);
  const canAccess = user?.role === userRoles?.admin || isLeadCustomFieldView;
  const canCreate = user?.role === userRoles?.admin || isLeadCustomFieldCreate;
  const canEdit = user?.role === userRoles?.admin || isLeadCustomFieldEdit;
  const canDelete = user?.role === userRoles?.admin || isLeadCustomFieldDelete;

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/signin");
      return;
    }

    if (!canAccess) {
      navigate("/dashboard-view");
    }
  }, [canAccess, isAuthenticated, navigate]);

  return (
    <LeadCustomFieldsContainer
      canView={canAccess}
      canCreate={canCreate}
      canEdit={canEdit}
      canDelete={canDelete}
    />
  );
};

export default LeadCustomFields;
